import { render, staticRenderFns } from "./fileCardForMaterialAttach.vue?vue&type=template&id=17e648b8&scoped=true&"
import script from "./fileCardForMaterialAttach.vue?vue&type=script&lang=js&"
export * from "./fileCardForMaterialAttach.vue?vue&type=script&lang=js&"
import style0 from "./fileCardForMaterialAttach.vue?vue&type=style&index=0&id=17e648b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e648b8",
  null
  
)

export default component.exports